export const SECONDS_PER_DAY = 24 * 60 * 60;
export const SECONDS_PER_HOUR = 60 * 60;
export const SECONDS_PER_MINUTE = 60;

export const SESSION_TIMEOUT = {
  MIN_SECONDS: SECONDS_PER_MINUTE,
  MAX_SECONDS: 14 * SECONDS_PER_DAY,
  DEFAULT_SECONDS: SECONDS_PER_HOUR,
} as const;

export const COEXISTENCE_TIMEOUT = {
  MIN_SECONDS: SECONDS_PER_MINUTE,
  MAX_SECONDS: 30 * SECONDS_PER_DAY,
  // The API rejects an Instagram timeout above 7 days.
  INSTAGRAM_MAX_SECONDS: 7 * SECONDS_PER_DAY,
  DEFAULT_SECONDS: 7 * SECONDS_PER_DAY,
} as const;
